import { render, staticRenderFns } from "./ScreenItems.vue?vue&type=template&id=50f46080&scoped=true&"
import script from "./ScreenItems.vue?vue&type=script&lang=js&"
export * from "./ScreenItems.vue?vue&type=script&lang=js&"
import style0 from "./ScreenItems.vue?vue&type=style&index=0&id=50f46080&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50f46080",
  null
  
)

export default component.exports